<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  method: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const emit = defineEmits(['edit', 'select']);
const { t } = useI18n();
const detail = computed(() =>
  props.method.tipo_pagamento === 'bank'
    ? [props.method.nome_banco, props.method.agencia, props.method.numero_conta]
        .filter(Boolean)
        .join(' · ')
    : props.method.chave_pix
);
const typeLabel = computed(() =>
  props.method.tipo_pagamento === 'bank'
    ? t('REAL_ESTATE_BROKER_COMMISSION.PAYMENT.BANK')
    : t('REAL_ESTATE_BROKER_COMMISSION.PAYMENT.PIX')
);
</script>

<template>
  <label
    class="relative flex cursor-pointer items-start gap-3 rounded-lais border p-4 pr-12 transition"
    :class="
      selected
        ? 'border-lais-primary bg-lais-primary-50/40'
        : 'border-lais-border bg-white hover:border-lais-primary'
    "
  >
    <input
      :checked="selected"
      class="mt-1 size-4 accent-lais-primary"
      name="broker-payment-method"
      type="radio"
      :value="method.id"
      @change="emit('select', method.id)"
    />
    <span class="min-w-0 flex-1">
      <span class="flex flex-wrap items-center gap-2">
        <span class="font-semibold text-lais-text">{{ method.apelido }}</span>
        <span
          v-if="method.principal"
          class="rounded-full bg-lais-bg-soft px-2 py-0.5 text-xs font-semibold text-lais-text-muted"
        >
          {{ t('REAL_ESTATE_BROKER_COMMISSION.DIALOG.PRIMARY') }}
        </span>
      </span>
      <span class="mt-1 block text-sm text-lais-text-body">{{
        typeLabel
      }}</span>
      <span class="mt-1 block break-all text-sm text-lais-text-muted">{{
        detail
      }}</span>
    </span>
    <button
      type="button"
      class="absolute right-3 top-3 grid size-8 place-items-center rounded-lais-sm text-lais-primary hover:bg-lais-primary-50"
      :title="t('REAL_ESTATE_BROKER_COMMISSION.ACTIONS.EDIT_METHOD')"
      @click.prevent.stop="emit('edit', method)"
    >
      <i class="i-lucide-pencil size-4" />
    </button>
  </label>
</template>
